import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import ConfigurationManager from './ConfigurationManager';
import ExampleConversationManager from './ExampleConversationManager';
import ConfigurationTester from './ConfigurationTester';
import GlobalCompanyContext from './GlobalCompanyContext';
import { useAppMeta } from '../../contexts/AppMetaContext';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`agent-config-tabpanel-${index}`}
      aria-labelledby={`agent-config-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

const AgentConfig: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);
  const { chatbotName } = useAppMeta();

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box className="fade-in">
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Configuración del Agente
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Configura el comportamiento, tono y respuestas de {chatbotName}
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="agent configuration tabs">
          <Tab label="Configuraciones" id="agent-config-tab-0" />
          <Tab label="Conversaciones de Ejemplo" id="agent-config-tab-1" />
          <Tab label="Probar Configuración" id="agent-config-tab-2" />
          <Tab label="Contexto Global Empresa" id="agent-config-tab-3" />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <ConfigurationManager />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <ExampleConversationManager />
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <ConfigurationTester />
      </TabPanel>
      <TabPanel value={tabValue} index={3}>
        <GlobalCompanyContext />
      </TabPanel>
    </Box>
  );
};

export default AgentConfig;
